import * as Sentry from '@sentry/react';

import { type LoggingContext } from '#packages/data-collection/types/logging-context';
import { type SentryReactConfig } from '#apps/client-web/app/config/sentry.browser';

export class SentryService {
  /* Prevent instantiation */
  private constructor() {}

  static async setup(
    opts: SentryReactConfig & Sentry.BrowserOptions,
    { logger }: LoggingContext = {},
  ): Promise<void> {
    logger?.debug({ opts }, 'Initializing Sentry...');

    Sentry.init({
      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
      attachStacktrace: true,

      ...opts,
    });

    logger?.debug('Sentry initialized successfully.');
  }
}
